<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z"
    />
    <text
      v-if="count || count === 0"
      :x="x"
      y="17"
      :class="computedTextClass"
      fill="#ffffff"
      :style="computedStyle"
    >
      {{ count }}
    </text>
  </svg>
</template>

<script>
const VIEWBOX_WIDTH = 24;

export default {
  name: 'pui-file-drag-icon',
  props: {
    /**
     * The count of dragging files
     *
     * @type {String}
     * @default null
     */
    count: {
      type: [String, Number],
      default: null,
    },
    /**
     * Extra class for the text element
     *
     * @type {String}
     * @default null
     */
    textClass: {
      type: String,
      default: null,
    },
  },
  computed: {
    /**
     * Viewbox for the svg element
     *
     * @returns {string} the viewbox string
     */
    viewBox() {
      return `0 0 ${VIEWBOX_WIDTH} 24`;
    },
    /**
     * @returns {object} class object for the text element
     */
    computedTextClass() {
      return {
        'file-thumbnail-text': true,
        [this.textClass]: this.textClass,
      };
    },
    /**
     * @returns {Number} scaled text length for the count
     */
    textLength() {
      if (!this.count && this.count !== 0) {
        return VIEWBOX_WIDTH;
      }

      return (this.count.toString().length / 4) * 12;
    },
    /**
     * @returns {Number} x coordinate for the text element so that
     * the actual text will be centered
     */
    x() {
      return VIEWBOX_WIDTH / 2 - this.textLength / 2;
    },
    /**
     * @returns {object} computed object style
     */
    computedStyle() {
      return {
        'font-weight': 'bold',
        'font-size': this.count.toString().length > 2 ? '7px' : '9px',
        'font-family': "'Open Sans', sans-serif",
      };
    },
  },
};
</script>
